<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25.7295 38L12.189 24.2525L25.7295 11.252" stroke="#212529" stroke-width="2" stroke-miterlimit="10"/>
<path d="M37 38L23.4595 24.2525L37 11.252" stroke="#212529" stroke-width="2" stroke-miterlimit="10"/>
</svg>
